import script from "./UserRole.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRole.vue?vue&type=script&setup=true&lang=js"

import "./UserRole.vue?vue&type=style&index=0&id=3e104a05&lang=css"

const __exports__ = script;

export default __exports__